<template>
  <v-date-picker
    v-model="date"
    :masks="masks"
    :model-config="modelConfig"
    :max-date="new Date()"
  >
    <template v-slot="{ inputValue, togglePopover }">
      <div class="input-group w-250">
        <div
          class="input-group-prepend"
          @click="togglePopover({ placement: 'auto-start' })"
        >
          <span class="input-group-text text-info bg-white is-pointer">
            <i
              class="fa fa-calendar"
              aria-hidden="true"
            />
          </span>
        </div>
        <input
          type="text"
          class="form-control form-control-sm bg-white w-250"
          :value="inputValue"
          readonly
          @click="togglePopover({ placement: 'auto-start' })"
        >
      </div>
    </template>
  </v-date-picker>
</template>

<script>
import { DatePicker as VDatePicker } from 'v-calendar'

export default {
  name: 'Date',

  components: {
    'v-date-picker': VDatePicker
  },

  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD'
      },
      masks: {
        input: 'YYYY-MM-DD'
      },
      date: this.value || null
    }
  },

  watch: {
    date (newDate) {
      this.$emit('input', newDate)
      this.$emit('returnDate', newDate, 'date')
    },
    value (newVal) {
      this.date = newVal
    }
  }
}
</script>

<style scoped>
.is-pointer {
  cursor: pointer;
}
.date-pick {
  height: 260px;
  background-color: white !important;
  z-index: 2;
}
input:focus {
  outline: none !important;
}
.input-group.w-250 {
  display: flex;
  width: 100% !important;
}
.input-group .form-control {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
